import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { useNavigate, useParams } from 'react-router';
import PageHeading from '../components/page_heading/PageHeading';
import { AMEND_DELIVERY_NOTE_STATUS_API, EMPLOYEE_CONFIRM_DELIVERY_NOTE_DELIVERED_API, EMPLOYEE_SUBMIT_DELIVERY_NOTE_FEEDACK_API, RETRIEVE_SPECIFIC_DELIVERY_NOTE_API, SUBMIT_CUSTOMER_FEEDBACK_API } from '../../../api/api_data';
import { fail_specific_delivery_note_details, loading_specific_delivery_note_details, reset_specific_delivery_note_details, success_specific_delivery_note_details } from '../../../reducers/dashboard_reducers/delivery_notes/specific_delivery_note_details_Slice';
import { AMEND_DELIVERY_NOTE_STATUS_ACCESS_DENIED_MSG, AMEND_DELIVERY_NOTE_STATUS_ERR_MSG, AMEND_DELIVERY_NOTE_STATUS_SUCCESS_MSG, CONFIRM_DELIVERY_NOTE_DELIVERED_ACCESS_DENIED_MSG, CONFIRM_DELIVERY_NOTE_DELIVERED_ERR_MSG, CONFIRM_DELIVERY_NOTE_DELIVERED_SUCCESS_MSG, RETRIEVE_SPECIFIC_DELIVERY_NOTE_ACCESS_DENIED_MSG, RETRIEVE_SPECIFIC_DELIVERY_NOTE_ERR_MSG, RETRIEVE_SPECIFIC_DELIVERY_NOTE_SUCCESS_MSG, SUBMIT_DELIVERY_NOTE_FEEDBACK_ACCESS_DENIED_MSG, SUBMIT_DELIVERY_NOTE_FEEDBACK_ERR_MSG, SUBMIT_DELIVERY_NOTE_FEEDBACK_SUCCESS_MSG } from '../../../constants/success_error_messages_consts';
import { employee_dashboard_actions_helper } from '../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { messageToast } from '../../../utils/Utils';
import * as app_consts from "../../../constants/react_app_consts";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon } from '../../../components/Component';
import CardTabs from '../components/cards/CardTabs';
import { Alert, Label, Spinner } from 'reactstrap';
import { useSelector } from 'react-redux';
import ProfileDetailText from '../components/text/ProfileDetailText';
import moment from 'moment';
import ReadOnlyTable from '../components/table/ReadOnlyTable';
import { fail_amend_delivery_note_status, loading_amend_delivery_note_status, reset_amend_delivery_note_status, success_amend_delivery_note_status } from '../../../reducers/dashboard_reducers/delivery_notes/amend_delivery_note_status_Slice';
import CheckListTable from '../components/table/CheckListTable';
import { BiErrorCircle } from 'react-icons/bi';
import DeliveryNotePDF from '../components/pdf/DeliveryNotePDF';
import { calculateTotalQuantity, findModuleAction, formatNumber, formatScientificNotation } from '../../../utils/functionalUtils';
import { PDFViewer } from '@react-pdf/renderer';
import { fail_confirm_delivery_note_delivered, loading_confirm_delivery_note_delivered, reset_confirm_delivery_note_delivered, success_confirm_delivery_note_delivered } from '../../../reducers/dashboard_reducers/delivery_notes/confirm_delivery_note_delivered_Slice';
import { fail_submit_feedback, loading_submit_feedback, reset_submit_feedback, success_submit_feedback } from '../../../reducers/dashboard_reducers/delivery_notes/submit_feedback_Slice';
import { EMPTYNULLREGEX } from '../../../utils/RegexUtils';
import { Link } from 'react-router-dom';
import ModalAdd from '../components/modal/modal_add/ModalAdd';
import { formatWeighbridgeWeightMt, resolveWeighbridgeNetWeight } from '../../../utils/weighbridgeUtils';
import LoadingOrderPDF from '../components/pdf/LoadingOrderPDF';

const product_list_type = app_consts.DELIVERY_NOTE_PRODUCT_LIST;
const initial_actions_data = { amend_delivery_note_status: false, continue_processing_weigh_bridge_ticket: false };
const type = app_consts.DELIVERY_NOTE_DETAILS;
const checkListTableType = app_consts.CUSTOMER_FEEDBACK_TABLE;
const initialFeedbackState = { product_list_feedback: [], comment_feedback: "", delivery_note_ref_number: "" };

// Card Tabs
const tabs = [
  {
    tabName: "Summary"
  },
  {
    tabName: "Weigh Bridge Information"
  },
  {
    tabName: "Delivery Note Products"
  },
  {
    tabName: "Delivery Note History"
  },
  {
    tabName: "Delivery Note PDF"
  },
  {
    tabName: "Customer Feedback"
  },
];


// Card Tabs
const loading_order_tabs = [
  {
    tabName: "Main Details"
  },
  {
    tabName: "Product Information"
  },
  {
    tabName: "Loading Order History"
  },
  {
    tabName: "Loading Order PDF"
  },
];

const DeliveryNoteDetails = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { delivery_note_ref_number } = useParams();
  const [activeCardTab, setActiveCardTab] = useState("Summary");
  const [dataFetched, setDataFetched] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [delivery_note_product_list, setDeliveryNoteProductlist] = useState([]);
  const [componentData, setComponentData] = useState(initial_actions_data);
  const [account_actions, setAccountActions] = useState([]);
  const [dn_history, setDnHistory] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [confirmError, setConfirmError] = useState("");
  const [delivery_feedBack, setDeliveryFeedback] = useState(initialFeedbackState);
  const [submitLoading, setSubmistLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [product_list_feedback, setProductListFeedback] = useState([]);
  const [sm, updateSm] = useState(false);
  const [defaultTabs, setDefaultTabs] = useState(tabs);
  const [add_products_to_direct_delivery, setAddProductsToDirectDelivery] = useState(false);
  const [finalize_dn_modal, setFinalizeDnModal] = useState(false);
  const [add_products_to_warehouse_delivery, setAddProductsToWarehouseDelivery] = useState(false);
  const [active_loading_order_tabs, setActiveLoadingOrderTabs] = useState("Main Details");

  // UseEffect to Run When the Page Opens
  useEffect(() => {
    setDeliveryFeedback({ ...delivery_feedBack, ["delivery_note_ref_number"]: delivery_note_ref_number });
    retrieve_specific_dn_details();
    if (localStorage.getItem("log_cred"))
    {
      setAccountActions(JSON.parse(localStorage.getItem('log_cred'))?.user_actions);
    }
  }, []);

  const retrieve_specific_dn_details = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_specific_delivery_note_details,
        success_specific_delivery_note_details,
        fail_specific_delivery_note_details,
        RETRIEVE_SPECIFIC_DELIVERY_NOTE_ERR_MSG,
        RETRIEVE_SPECIFIC_DELIVERY_NOTE_SUCCESS_MSG,
        app_consts.POST,
        RETRIEVE_SPECIFIC_DELIVERY_NOTE_API,
        { delivery_note_ref_number: delivery_note_ref_number },
        RETRIEVE_SPECIFIC_DELIVERY_NOTE_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Changes In Account Actions
  useEffect(() => {
    if (account_actions)
    {
      let actions_data = initial_actions_data;
      account_actions?.map((module) => {
        if (module.module_name === app_consts.WAREHOUSE_MANAGEMENT) 
        {
          // Actions Data
          if (findModuleAction(app_consts.CONTINUE_PROCESSING_DELIVERY_WEIGH_BRIDGE_TICKET, module))
          {
            actions_data.continue_processing_weigh_bridge_ticket = true;
          }
        }
      });
      setComponentData(actions_data);
    }
  }, [account_actions]);

  // Listen to Reducer
  const delivery_note_details = useSelector((state) => state.specific_delivery_note_details.specific_delivery_note_details);
  // 
  useEffect(() => {
    if (delivery_note_details.status !== app_consts.IDLE)
    {
      if (delivery_note_details.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (delivery_note_details.status === app_consts.FAIL)
        {
          setError(delivery_note_details.message);
          messageToast(delivery_note_details.message, app_consts.FAIL);
        } else if (delivery_note_details.status === app_consts.SUCCESS)
        {
          setPageData(delivery_note_details.data);
          setDataFetched(true);
          setDeliveryNoteProductlist(delivery_note_details.data?.product_list);
          setDnHistory(delivery_note_details.data?.delivery_note?.delivery_note_history);

          if (delivery_note_details.data?.grn_schedule && !defaultTabs?.some(tab => tab?.tabName === "Goods Received Schedule"))
          {
            setDefaultTabs(prev => [...prev, { tabName: "Goods Received Schedule" }]);
          }
          if (delivery_note_details.data?.delivery_note?.loading_order_id && !defaultTabs?.some(tab => tab?.tabName === "Loading Order Details"))
          {
            setDefaultTabs(prev => [...prev, { tabName: "Loading Order Details" }]);
          }
        }
        dispatch(reset_specific_delivery_note_details());
      }
    }
  }, [delivery_note_details]);


  const amend_delivery_note_status_func = (delivery_note_status) => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_amend_delivery_note_status,
        success_amend_delivery_note_status,
        fail_amend_delivery_note_status,
        AMEND_DELIVERY_NOTE_STATUS_ERR_MSG,
        AMEND_DELIVERY_NOTE_STATUS_SUCCESS_MSG,
        app_consts.POST,
        AMEND_DELIVERY_NOTE_STATUS_API,
        { delivery_note_ref_number: delivery_note_ref_number, delivery_note_status: delivery_note_status },
        AMEND_DELIVERY_NOTE_STATUS_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Reducer For Amending Status
  const amend_delivery_note_status = useSelector((state) => state.amend_delivery_note_status.amend_delivery_note_status);
  // 
  useEffect(() => {
    if (amend_delivery_note_status.status !== app_consts.IDLE)
    {
      if (amend_delivery_note_status.status === app_consts.LOADING)
      {
        // setLoading(true);
      } else
      {
        setLoading(false);
        if (amend_delivery_note_status.status === app_consts.FAIL)
        {
          messageToast(amend_delivery_note_status.message, app_consts.FAIL);
        } else if (amend_delivery_note_status.status === app_consts.SUCCESS)
        {
          messageToast(amend_delivery_note_status.message, app_consts.SUCCESS);
          setPageData(amend_delivery_note_status.data);
          setDataFetched(true);
          setDeliveryNoteProductlist(amend_delivery_note_status.data?.product_list);
        }
        dispatch(reset_amend_delivery_note_status());
      }
    }
  }, [amend_delivery_note_status]);


  const pageHeadingActions = (type, received_data) => {
    if (type === app_consts.COMP_AMEND_DELIVERY_NOTE_STATUS_ACTIONS)
    {
      amend_delivery_note_status_func(received_data);
    }
    else if (type === app_consts.CONTINUE_PROCESSING_DELIVERY_NOTE_ACTIONS)
    {
      if (page_data?.weigh_bridge_ticket_type?.weigh_bridge_ticket_type_id === app_consts.PHYSICAL_TICKET_TYPE ||
        page_data?.weigh_bridge_ticket_type?.weigh_bridge_ticket_type_id === app_consts.VIRTUAL_TICKET_TYPE)
      {
        navigate(`/dashboard/delivery_notes/continue_processing_physical/${delivery_note_ref_number}`);
      }
    }
  };


  // Confirm Delivery Note Delivered
  const confirm_delivered_note_delivered = () => {
    setConfirmError("");
    dispatch(
      employee_dashboard_actions_helper(
        loading_confirm_delivery_note_delivered,
        success_confirm_delivery_note_delivered,
        fail_confirm_delivery_note_delivered,
        CONFIRM_DELIVERY_NOTE_DELIVERED_ERR_MSG,
        CONFIRM_DELIVERY_NOTE_DELIVERED_SUCCESS_MSG,
        app_consts.POST,
        EMPLOYEE_CONFIRM_DELIVERY_NOTE_DELIVERED_API,
        { delivery_note_ref_number: delivery_note_ref_number },
        CONFIRM_DELIVERY_NOTE_DELIVERED_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Reducer
  const confirm_delivery_note = useSelector((state) => state.confirm_delivery_note_delivered.confirm_delivery_note_delivered);
  // 
  useEffect(() => {
    if (confirm_delivery_note.status !== app_consts.IDLE)
    {
      if (confirm_delivery_note.status === app_consts.LOADING)
      {
        setConfirmError("");
        setConfirmLoading(true);
      } else
      {
        setConfirmLoading(false);
        if (confirm_delivery_note.status === app_consts.FAIL)
        {

          setConfirmError(confirm_delivery_note.message);
          messageToast(confirm_delivery_note.message, app_consts.FAIL);
        } else if (confirm_delivery_note.status === app_consts.SUCCESS)
        {
          messageToast(CONFIRM_DELIVERY_NOTE_DELIVERED_SUCCESS_MSG, app_consts.SUCCESS);
          setPageData(confirm_delivery_note.data);
          setDataFetched(true);
          setDeliveryNoteProductlist(confirm_delivery_note.data?.product_list);
        }
        dispatch(reset_confirm_delivery_note_delivered());
      }
    }
  }, [confirm_delivery_note]);

  const selectFeedbackOption = (delivery_note_product_id, selected_value) => {
    setProductListFeedback({ ...product_list_feedback, [`delivery_note_product_id`]: delivery_note_product_id, ["delivery_note_feedBack_value"]: selected_value });
  };

  // Handle Submit
  const handleSubmit = () => {
    setSubmitError("");
    if (delivery_feedBack.product_list_feedback?.length === 0)
    {
      messageToast("Please Give Feedback for All Products Delivered on the List.", app_consts.FAIL);
    }
    else
    {
      dispatch(
        employee_dashboard_actions_helper(
          loading_submit_feedback,
          success_submit_feedback,
          fail_submit_feedback,
          SUBMIT_DELIVERY_NOTE_FEEDBACK_ERR_MSG,
          SUBMIT_DELIVERY_NOTE_FEEDBACK_SUCCESS_MSG,
          app_consts.POST,
          EMPLOYEE_SUBMIT_DELIVERY_NOTE_FEEDACK_API,
          delivery_feedBack,
          SUBMIT_DELIVERY_NOTE_FEEDBACK_ACCESS_DENIED_MSG
        )
      );
    }
  };

  // Listen to Reducer
  const submit_feedback = useSelector((state) => state.submit_feedback.submit_feedback);
  // 
  useEffect(() => {
    if (submit_feedback.status !== app_consts.IDLE)
    {
      if (submit_feedback.status === app_consts.LOADING)
      {
        setSubmitError("");
        setSubmistLoading(true);
      } else
      {
        setSubmistLoading(false);
        if (submit_feedback.status === app_consts.FAIL)
        {

          setSubmitError(submit_feedback.message);
          messageToast(submit_feedback.message, app_consts.FAIL);
        } else if (submit_feedback.status === app_consts.SUCCESS)
        {
          messageToast(SUBMIT_DELIVERY_NOTE_FEEDBACK_SUCCESS_MSG, app_consts.SUCCESS);
          setPageData(submit_feedback.data);
          setDataFetched(true);
          setDeliveryNoteProductlist(submit_feedback.data?.product_list);
          dispatch(
            employee_dashboard_actions_helper(
              loading_specific_delivery_note_details,
              success_specific_delivery_note_details,
              fail_specific_delivery_note_details,
              RETRIEVE_SPECIFIC_DELIVERY_NOTE_ERR_MSG,
              RETRIEVE_SPECIFIC_DELIVERY_NOTE_SUCCESS_MSG,
              app_consts.POST,
              RETRIEVE_SPECIFIC_DELIVERY_NOTE_API,
              { delivery_note_ref_number: delivery_note_ref_number },
              RETRIEVE_SPECIFIC_DELIVERY_NOTE_ACCESS_DENIED_MSG
            )
          );
        }
        dispatch(reset_submit_feedback());
      }
    }
  }, [submit_feedback]);

  const check_feedback_entries_being_added = () => {
    let return_data = true;
    const feed_list = delivery_feedBack?.product_list_feedback;
    if (feed_list?.length === delivery_note_product_list?.length)
    {
      // Filter Out Values that are Empty
      const filtered_data = feed_list?.filter((dat) => EMPTYNULLREGEX.test(dat?.delivery_note_feedBack_value));

      if (filtered_data?.length > 0)
      {
        return_data = false;
      }
      else
      {
        return_data = true;
      }
    }
    else
    {
      return_data = false;
    }

    return return_data;
  };

  useEffect(() => {
    if ((product_list_feedback && product_list_feedback.length > 0) || (product_list_feedback.length !== delivery_note_product_list?.length))
    {
      setDeliveryFeedback({ ...delivery_feedBack, ["product_list_feedback"]: [product_list_feedback] });
    }
  }, [product_list_feedback]);

  const open_add_products_to_direct_delivery = () => {
    setAddProductsToDirectDelivery(true);
  };

  const close_add_products_to_direct_delivery = () => {
    setAddProductsToDirectDelivery(false);
  };

  const successAddProductsFunction = () => {
    close_add_products_to_direct_delivery();
    close_add_products_to_warehouse_delivery();
    retrieve_specific_dn_details();
  };


  const open_finalize_dn_modal = () => {
    setFinalizeDnModal(true);
  };

  const close_finalize_dn_modal = () => {
    setFinalizeDnModal(false);
  };

  const successFinalizeDnFunction = () => {
    close_finalize_dn_modal();
    retrieve_specific_dn_details();
    setActiveCardTab("Delivery Note PDF");
  };


  const open_add_products_to_warehouse_delivery = () => {
    setAddProductsToWarehouseDelivery(true);
  };

  const close_add_products_to_warehouse_delivery = () => {
    setAddProductsToWarehouseDelivery(false);
  };


  return (
    <>
      <Head title={`Delivery Note Details - ${delivery_note_ref_number}`} />
      <Content>
        <Block>
          <BlockHead size="sm">
            <BlockBetween className="g-3">
              <BlockHeadContent>
                <BlockTitle page>{`Delivery Note Details | ${delivery_note_ref_number}`}</BlockTitle>
                <Link to={`/dashboard/delivery_notes`}>
                  <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                    <Icon name="arrow-left"></Icon>
                    <span>Back</span>
                  </Button>
                </Link>
                <Link to={`/dashboard/delivery_notes`}>
                  <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                    <Icon name="arrow-left"></Icon>
                  </Button>
                </Link>
              </BlockHeadContent>
              <BlockHeadContent>
                <div className="toggle-wrap nk-block-tools-toggle">
                  <Button
                    className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                    onClick={() => updateSm(!sm)}
                  >
                    <Icon name="menu-alt-r"></Icon>
                  </Button>
                  <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                    <ul className="nk-block-tools g-3">
                      {
                        findModuleAction(app_consts.CONTINUE_PROCESSING_DELIVERY_WEIGH_BRIDGE_TICKET, componentData) !== null && (
                          <>
                            {
                              page_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status?.toLowerCase() === app_consts.PROCESSING_OUTBOUND && (
                                <>
                                  <li>
                                    <Button color="light" outline className="btn-white" onClick={() => { if (page_data?.grn_schedule) { open_add_products_to_direct_delivery(); } else { open_add_products_to_warehouse_delivery(); } }} >
                                      <Icon name="plus"></Icon>
                                      <span>Add Products</span>
                                    </Button>
                                  </li>
                                </>
                              )}
                            {
                              page_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status?.toLowerCase() === app_consts.ONBOARDING_GOODS && (
                                <>
                                  <li>
                                    <Button color="light" outline className="btn-white" onClick={open_finalize_dn_modal} >
                                      <Icon name="notice"></Icon>
                                      <span>Finalize DN</span>
                                    </Button>
                                  </li>
                                </>
                              )}
                          </>
                        )}
                      {/* {
                                            (findModuleAction(app_consts.CREATE_GOODS_RECEIVED_WEIGH_BRIDGE_TICKET, componentData) !== null || findModuleAction(app_consts.CREATE_DELIVERY_NOTE_WEIGH_BRIDGE_TICKET, componentData) !== null) && (
                                                <>
                                                    {
                                                        page_data?.goods_received?.grn_origin === "grn_schedule" && (
                                                            <>
                                                                <li className="preview-item">
                                                                    <UncontrolledDropdown>
                                                                        <div className="btn-group">
                                                                            <DropdownToggle color="light" outline className="dropdown-toggle-split btn-white">
                                                                                <Icon name="chevron-down"></Icon>

                                                                                <span>Actions</span>
                                                                            </DropdownToggle>
                                                                        </div>
                                                                        <DropdownMenu className="mt-3">
                                                                            <ul className="link-list-opt">
                                                                                {
                                                                                    findModuleAction(app_consts.CREATE_GOODS_RECEIVED_WEIGH_BRIDGE_TICKET, componentData) !== null && page_data?.grn_schedule?.status === "in_transit" && (
                                                                                        <>
                                                                                            <li>
                                                                                                <DropdownItem
                                                                                                    tag="a"
                                                                                                    href="#"
                                                                                                    onClick={(ev) => {
                                                                                                        ev.preventDefault();
                                                                                                        open_receive_grn_modal();
                                                                                                    }}
                                                                                                >
                                                                                                    <span>Receive Goods Into Warehouse</span>
                                                                                                </DropdownItem>
                                                                                            </li>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    findModuleAction(app_consts.CREATE_DELIVERY_NOTE_WEIGH_BRIDGE_TICKET, componentData) !== null && (page_data?.grn_schedule?.quantity_offloaded || 0.00) < page_data?.grn_schedule?.tonnage && (
                                                                                        <>
                                                                                            <li>
                                                                                                <DropdownItem
                                                                                                    tag="a"
                                                                                                    href="#"
                                                                                                    onClick={(ev) => {
                                                                                                        ev.preventDefault();
                                                                                                        open_create_direct_delivery_note_modal();
                                                                                                    }}
                                                                                                >
                                                                                                    <span>Create Direct Delivery Note</span>
                                                                                                </DropdownItem>
                                                                                            </li>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                            </ul>
                                                                        </DropdownMenu>
                                                                    </UncontrolledDropdown>
                                                                </li>
                                                            </>
                                                        )
                                                    }
                                                </>
                                            )
                                        } */}
                    </ul>
                  </div>
                </div>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>
          {
            loading ?
              <>
                <div className='w-full p-5 d-flex justify-center items-center'>
                  <Spinner />
                </div>
              </>
              :
              error && error.length > 0 ?
                <>
                  <div className='text-soft alert-icon w-full p-5 d-flex justify-center items-center fw-bold fs-18px'>
                    {error}
                  </div>
                </>
                :
                <>
                  <CardTabs cardTabs={defaultTabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} dataFetched={setDataFetched} />
                  <div className="card-inner">
                    {
                      activeCardTab === "Summary" && (
                        <>
                          <Block>
                            <BlockHead>
                              <BlockTitle tag="h5">Delivery Note Summary</BlockTitle>
                              <p>A Brief Summary of Delivery Note.</p>
                            </BlockHead>
                            <BlockHead>
                              <BlockTitle tag="h6">Brief Summary</BlockTitle>
                            </BlockHead>
                            <div className="profile-ud-list">
                              <ProfileDetailText label="Reference Number" text={page_data?.delivery_note?.delivery_note_ref_number || "---"} />
                              <ProfileDetailText label="Status" text={page_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status || "---"} textClassName={page_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status_id === app_consts.WEIGH_BRIDGE_TICKET_PROCESSING_COMPLETE || page_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status_id === app_consts.WEIGH_BRIDGE_TICKET_DELIVERED ? "text-success" : "text-warning"} />
                              <ProfileDetailText label="Date Created" text={page_data?.delivery_note?.created_date ? moment(page_data?.delivery_note?.created_date).format("MMMM Do, YYYY h:mm:ss") : "---"} />
                              <ProfileDetailText label="Delivery Location" text={page_data?.delivery_note?.delivery_location || "---"} />
                              <ProfileDetailText label="Transit Date" text={page_data?.delivery_note?.transit_date_time ? moment(page_data?.delivery_note?.transit_date_time).format("MMMM Do, YYYY h:mm:ss") : "---"} />
                              <ProfileDetailText label="Delivery Date" text={page_data?.delivery_note?.delivery_date_time ? moment(page_data?.delivery_note?.delivery_date_time).format("MMMM Do, YYYY h:mm:ss") : "---"} />
                            </div>
                            <BlockHead className='mt-5'>
                              <BlockTitle tag="h6">Consigner Details</BlockTitle>
                            </BlockHead>
                            <div className="profile-ud-list">
                              <ProfileDetailText label="User ID" text={page_data?.user_account?.unique_identification_number || "---"} />
                              <ProfileDetailText label="Name" text={page_data?.consigner?.name || "---"} />
                              <ProfileDetailText label="Email Address" text={page_data?.consigner?.email || "---"} />
                              <ProfileDetailText label="Mobile number" text={page_data?.consigner?.mobile_number || "---"} />
                            </div>
                            <BlockHead className='mt-5'>
                              <BlockTitle tag="h6">Customer Receiving Details</BlockTitle>
                            </BlockHead>
                            <div className="profile-ud-list">
                              <ProfileDetailText label="Name" text={page_data?.delivery_note?.customer_receiving_name || "---"} />
                              <ProfileDetailText label="Primary Mobile Number" text={page_data?.delivery_note?.customer_receiving_primary_mobile || "---"} />
                              <ProfileDetailText label="Secondary Mobile Number" text={page_data?.delivery_note?.customer_receiving_secondary_mobile || "---"} />
                            </div>
                          </Block>
                        </>
                      )
                    }
                    {
                      activeCardTab === "Weigh Bridge Information" && (
                        <>
                          <Block>
                            <BlockHead>
                              <BlockTitle tag="h5">Delivery Information</BlockTitle>
                              <p>Weigh Bridge Details</p>
                            </BlockHead>
                            <BlockHead>
                              <BlockTitle tag="h6">Weigh Bridge Details</BlockTitle>
                            </BlockHead>
                            <div className="profile-ud-list">
                              <ProfileDetailText label="Weigh Bridge Ticket Number" text={page_data?.weigh_bridge_ticket?.weigh_bridge_ticket_reference_no || "---"} />
                              <ProfileDetailText label="Tare Weight" text={formatWeighbridgeWeightMt(page_data?.weigh_bridge_ticket?.first_weight)} />
                              <ProfileDetailText label="Gross Weight" text={formatWeighbridgeWeightMt(page_data?.weigh_bridge_ticket?.second_weight)} />
                              <ProfileDetailText
                                label="Net Weight"
                                text={formatWeighbridgeWeightMt(
                                  resolveWeighbridgeNetWeight(
                                    page_data?.weigh_bridge_ticket?.net_weight,
                                    page_data?.weigh_bridge_ticket?.first_weight,
                                    page_data?.weigh_bridge_ticket?.second_weight,
                                  ),
                                )}
                              />
                            </div>
                            <BlockHead className='mt-5'>
                              <BlockTitle tag="h6">Consigner Details</BlockTitle>
                            </BlockHead>
                            <div className="profile-ud-list">
                              <ProfileDetailText label="User ID" text={page_data?.user_account?.unique_identification_number || "---"} />
                              <ProfileDetailText label="Name" text={page_data?.consigner?.name || "---"} />
                              <ProfileDetailText label="Email Address" text={page_data?.consigner?.email || "---"} />
                              <ProfileDetailText label="Mobile number" text={page_data?.consigner?.mobile_number || "---"} />
                            </div>
                          </Block>
                        </>
                      )
                    }
                    {
                      activeCardTab === "Delivery Note Products" && (
                        <>
                          <Block>
                            <BlockHead>
                              <BlockTitle tag="h5">Delivery Note Products</BlockTitle>
                              <p>Delivery Note product List</p>
                            </BlockHead>
                            <div className="nk-tb-list is-separate is-medium mt-1 mb-3">
                              <div className="card-inner p-0">
                                <DataTableBody>
                                  <DataTableHead className="nk-tb-item">
                                    <DataTableRow size="lg"><span className="sub-text">Product</span></DataTableRow>
                                    <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
                                    <DataTableRow size="lg"><span className="sub-text">Unit Weight (KGs)</span></DataTableRow>
                                    <DataTableRow size="lg"><span className="sub-text">Base Weight</span></DataTableRow>
                                    <DataTableRow size="lg"><span className="sub-text">Density Weight</span></DataTableRow>
                                    <DataTableRow size="lg"><span className="sub-text">Packaging Number</span></DataTableRow>
                                    <DataTableRow size="lg"><span className="sub-text">Density Capacity (MT)</span></DataTableRow>
                                    <DataTableRow size="lg"><span className="sub-text">Base Capacity (MT)</span></DataTableRow>
                                  </DataTableHead>
                                  {delivery_note_product_list?.length > 0 &&
                                    delivery_note_product_list?.map((item) => (
                                      <DataTableItem key={item.id}>
                                        <DataTableRow>
                                          <span className="tb-sub">{item?.product_name || "--"}</span>

                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-sub">{item?.packet_size || "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-sub">{item?.uom_details?.measurement_in_kilos ? formatNumber(parseFloat(item?.uom_details?.measurement_in_kilos)?.toFixed(2)) : "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-sub">{item?.uom_details?.measurement_in_kilos ? formatNumber(parseFloat(item?.uom_details?.measurement_in_kilos)?.toFixed(2)) : "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-sub">{item?.uom_details?.density_in_kilos ? formatNumber(parseFloat(item?.uom_details?.density_in_kilos)?.toFixed(2)) : "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow><span className="tb-sub">{item?.total_capacity_selected_measurement ? formatNumber(parseFloat(item?.total_capacity_selected_measurement)?.toFixed(2)) : "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-sub">{item?.uom_details?.total_density_kilos ? formatNumber(parseFloat(item?.uom_details?.total_density_kilos)?.toFixed(2)) : "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-sub">{item?.total_capacity_in_mt ? formatNumber(parseFloat(item?.total_capacity_in_mt)?.toFixed(2)) : "--"}</span>
                                        </DataTableRow>
                                      </DataTableItem>
                                    ))}
                                </DataTableBody>
                              </div>
                            </div>
                          </Block>
                        </>
                      )
                    }
                    {
                      activeCardTab === "Delivery Note History" && (
                        <>
                          <Block>
                            <BlockHead>
                              <BlockTitle tag="h5">Delivery Note History</BlockTitle>
                              <p>Historical Data on Delivery Note Changes</p>
                            </BlockHead>
                            {/* Table */}
                            <div className="my-3">
                              <ReadOnlyTable data={dn_history} tableType={app_consts.GRN_HISTORY} />
                            </div>
                          </Block>
                        </>
                      )
                    }

                    {
                      activeCardTab === "Delivery Note PDF" && (
                        <>
                          {
                            page_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status_id === app_consts.WEIGH_BRIDGE_TICKET_PROCESSING_COMPLETE || page_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status_id === app_consts.WEIGH_BRIDGE_TICKET_IN_TRANSIT || page_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status_id === app_consts.WEIGH_BRIDGE_TICKET_DELIVERED ?
                              <>
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Delivery Note PDF</BlockTitle>
                                    <p>Printable Doucment with Delivery Note Details</p>
                                  </BlockHead>
                                  <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                                    <PDFViewer height="100%" width="100%" showToolbar>
                                      <DeliveryNotePDF page_data={page_data} />
                                    </PDFViewer>
                                  </div>
                                </Block>
                              </>
                              :
                              <>
                                <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                                  <BiErrorCircle className="text-danger fs-13" />
                                  <p>Cannot View Delivery Note PDF.</p>
                                  <p>Delivery Note Processing is Incomplete.</p>
                                </div>
                              </>
                          }
                        </>
                      )
                    }
                    {
                      activeCardTab === "Customer Feedback" && (
                        <>
                          <Block>
                            <BlockHead>
                              <BlockTitle tag="h5">Customer Feedback</BlockTitle>
                              <p>Customer Feedback on Delivery Notes Goods</p>
                            </BlockHead>
                            {/* Check if Status is Delivered */}
                            {
                              page_data?.weigh_bridge_ticket_status.weigh_bridge_ticket_status_id === app_consts.WEIGH_BRIDGE_TICKET_DELIVERED ?
                                <>
                                  <div className='d-flex flex-row justify-between'>
                                    <div className="my-3 w-55">
                                      <CheckListTable amendFunction={selectFeedbackOption} data={delivery_note_product_list} tableType={checkListTableType} editMode={!page_data?.delivery_note?.customer_feedback_set} />
                                    </div>
                                    {
                                      page_data?.delivery_note?.customer_feedback_set ?
                                        <>
                                          <div className="profile-ud-item">
                                            <div className="d-flex flex-column">
                                              <div className="d-flex flex-column">
                                                <span className="profile-ud-label">Comments</span>
                                                <span className={`profile-ud-value`}>{page_data?.delivery_note?.customer_feedback_comments || "---"}</span>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                        :
                                        <>
                                          <div className=" w-40 h-auto">
                                            <div className="form-group">
                                              <Label htmlFor="default-textarea" className="form-label">
                                                Comments (Optional)
                                              </Label>
                                              <div className="form-control-wrap">
                                                <textarea
                                                  className="no-resize form-control "
                                                  type="textarea"
                                                  id="default-textarea"
                                                  value={delivery_feedBack.comment_feedback}
                                                  onChange={(e) => setDeliveryFeedback({ ...delivery_feedBack, ["comment_feedback"]: e.target.value })}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                    }
                                  </div>
                                  {submitError && (
                                    <div className="mb-3 w-50 m-auto">
                                      <Alert color="danger" className="alert-icon">
                                        <Icon name="alert-circle" /> {submitError}{" "}
                                      </Alert>
                                    </div>
                                  )}
                                  {
                                    !page_data?.delivery_note?.customer_feedback_set && (
                                      <>
                                        <Col xl="12">
                                          <div className="form-group">
                                            <div className="mt-4 form-control-wrap-flex-wrap justify-center items">
                                              <Button
                                                onClick={handleSubmit}
                                                disabled={submitLoading || !(check_feedback_entries_being_added())}
                                                color="primary"
                                                size="lg"
                                              >
                                                {submitLoading ? <Spinner size="sm" color="light" /> : "Submit FeedBack"}
                                              </Button>
                                            </div>
                                          </div>
                                        </Col>
                                      </>
                                    )
                                  }
                                </>
                                :
                                <>
                                  <div className='text-soft alert-icon w-full p-5 d-flex justify-center items-center fw-bold fs-18px'>
                                    Customer Feedback Can Only Be Submitted After a Customer Confirms Arrival of Delivery that is in Transit.
                                  </div>
                                  <div className='text-soft alert-icon w-full d-flex justify-center items-center fs-16px'>
                                    <div className='p-1'>Current Status: </div><div className='fw-bold primary p-1 upprcase'>{page_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status}</div>
                                  </div>
                                  {confirmError && (
                                    <div className="mb-3 w-50 m-auto">
                                      <Alert color="danger" className="alert-icon">
                                        <Icon name="alert-circle" /> {confirmError}{" "}
                                      </Alert>
                                    </div>
                                  )}
                                  <div className='text-soft alert-icon w-full p-2 d-flex justify-center items-center fw-bold fs-18px'>
                                    <Button onClick={confirm_delivered_note_delivered} color="primary" size="lg" disabled={confirmLoading ? confirmLoading : page_data?.weigh_bridge_ticket_status.weigh_bridge_ticket_status_id !== app_consts.WEIGH_BRIDGE_TICKET_IN_TRANSIT}>
                                      {confirmLoading ? <Spinner size="sm" color="light" /> : "Confirm Delivery"}
                                    </Button>
                                  </div>
                                </>
                            }
                          </Block>
                        </>
                      )
                    }
                    {
                      activeCardTab === "Goods Received Schedule" && (
                        <>
                          <BlockHead>
                            <BlockTitle tag="h6">Goods Received Schedule</BlockTitle>
                          </BlockHead>
                          <div className="profile-ud-list">
                            <ProfileDetailText label="Name" text={page_data?.grn_schedule?.name || "---"} />
                            <ProfileDetailText label="Horse Reg No" text={page_data?.grn_schedule?.horse_reg || "---"} />
                            <ProfileDetailText label="Trailer Reg No 1" text={page_data?.grn_schedule?.trailer_reg_one || "---"} />
                            <ProfileDetailText label="Trailer Reg No 2" text={page_data?.grn_schedule?.trailer_reg_two || "---"} />
                            <ProfileDetailText label="Driver" text={page_data?.grn_schedule?.driver || "---"} />
                            <ProfileDetailText label="Transporter" text={page_data?.grn_schedule?.transporter || "---"} />
                            <ProfileDetailText label="Tonnage" text={page_data?.grn_schedule?.tonnage || "0.00"} />
                            <ProfileDetailText label="Quantity Offloaded" text={page_data?.grn_schedule?.quantity_offloaded || "0.00"} />
                            <ProfileDetailText label="Cargo Details" text={page_data?.grn_schedule?.cargo_details || "---"} />
                            <ProfileDetailText label="Offload Point" text={page_data?.grn_schedule?.offload_point || "---"} />
                            <ProfileDetailText label="Date Loaded" text={page_data?.grn_schedule?.data_loaded || "---"} />
                            <ProfileDetailText label="Load Reference" text={page_data?.grn_schedule?.load_reference || "---"} />
                            <ProfileDetailText label="Created On" text={page_data?.grn_schedule?.inserted_at ? moment(page_data?.grn_schedule?.inserted_at).format("MMMM Do, YYYY") : "---"} />
                            <ProfileDetailText label="Status" text={page_data?.grn_schedule?.status || "---"} />
                          </div>
                        </>
                      )
                    }
                    {
                      activeCardTab === "Loading Order Details" && (
                        <>
                          <BlockHead className="mb-4">
                            <BlockTitle tag="h6">Loading Order Details</BlockTitle>
                          </BlockHead>
                          <CardTabs cardTabs={loading_order_tabs} activeCardTab={active_loading_order_tabs} setActiveCardTab={setActiveLoadingOrderTabs} dataFetched={dataFetched} />
                          {
                            active_loading_order_tabs === "Main Details" && (
                              <>
                                <Block>
                                  <div className="profile-ud-list">
                                    <ProfileDetailText label="Goods Received Reference Number" text={page_data?.loading_order?.loading_order_ref_no || "---"} />
                                    <ProfileDetailText label="Status" text={page_data?.loading_order?.loading_order_status || "---"} textClassName={page_data?.loading_order?.loading_order_status_id === app_consts.WEIGH_BRIDGE_TICKET_PROCESSING_COMPLETE ? "text-success" : "text-warning"} />
                                    <ProfileDetailText label="Date Created" text={page_data?.loading_order?.inserted_at ? moment(page_data?.loading_order?.inserted_at).format("MMMM Do, YYYY") : "---"} />
                                    <ProfileDetailText label="Total Quantity" text={page_data?.loading_order?.products ? formatScientificNotation(`${calculateTotalQuantity(page_data?.loading_order?.products, "total_mt_capacity")} MT`) : "---"} />
                                    <ProfileDetailText label="Loading Order Type" text={page_data?.loading_order?.loading_order_type ? page_data?.loading_order?.loading_order_type : "---"} />
                                  </div>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Consigner Details</BlockTitle>
                                    <p>Entity that the Loading Order Belongs to</p>
                                  </BlockHead>
                                  <div className="profile-ud-list">
                                    <ProfileDetailText label="User ID" text={page_data?.loading_order?.consigner?.unique_identification_number || "---"} />
                                    <ProfileDetailText label="Name" text={page_data?.loading_order?.consigner?.username || "---"} />
                                    <ProfileDetailText label="Contact person" text={page_data?.loading_order?.contact_person || "---"} />
                                    <ProfileDetailText label="Contact Mobile" text={page_data?.loading_order?.contact_mobile || "---"} />
                                  </div>
                                  <BlockHead className='mt-5'>
                                    <BlockTitle tag="h6">Transport Details</BlockTitle>
                                  </BlockHead>
                                  <div className="profile-ud-list">
                                    <ProfileDetailText label="Transporter Name" text={page_data?.loading_order?.transporter_name || "---"} />
                                    <ProfileDetailText label="Truck Driver Name" text={page_data?.loading_order?.truck_driver_name || "---"} />
                                    <ProfileDetailText label="Truck Reg No" text={page_data?.loading_order?.truck_license_plate || "---"} />
                                    <ProfileDetailText label="Trailer Reg 1 No" text={page_data?.loading_order?.trailer_one || "---"} />
                                    <ProfileDetailText label="Trailer Reg 2 No" text={page_data?.loading_order?.trailer_two || "---"} />
                                  </div>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Loading Instructions</BlockTitle>
                                  </BlockHead>
                                  {/* Table */}
                                  <div className="my-3">
                                    <ReadOnlyTable data={page_data?.loading_order?.driver_instructions} tableType={app_consts.DRIVER_INSTRUCTIONS_TABLE} />
                                  </div>
                                </Block>
                              </>
                            )
                          }
                          {
                            active_loading_order_tabs === "Product Information" && (
                              <>
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Loading Order Products</BlockTitle>
                                    <p className='d-flex flex-row' style={{ marginRight: 2 }}>Products: <p className='fw-600' style={{ marginLeft: 2 }}>{page_data?.loading_order?.products?.length}</p> </p>
                                    <p className='d-flex flex-row' style={{ marginRight: 2 }}>Total Capacity: <p className='fw-600' style={{ marginLeft: 2 }}>{`${page_data?.loading_order?.products ? formatScientificNotation(`${calculateTotalQuantity(page_data?.loading_order?.products, "total_mt_capacity")} MT`) : ""}`}</p> </p>
                                  </BlockHead>
                                  {/* Table */}
                                  <div className="my-3">
                                    <ReadOnlyTable data={page_data?.loading_order?.products} tableType={app_consts.NOT_LOADED_PRODUCTS_LOADING_ORDER_DETAILS} />
                                  </div>
                                </Block>
                              </>
                            )
                          }
                          {
                            active_loading_order_tabs === "Loading Order History" && (
                              <>
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Loading Order History</BlockTitle>
                                    <p>Historical Data on Loading Order Amendments</p>
                                  </BlockHead>
                                  {/* Table */}
                                  <div className="my-3">
                                    <ReadOnlyTable data={page_data?.loading_order?.inventory_history} tableType={app_consts.GRN_HISTORY} />
                                  </div>
                                </Block>
                              </>
                            )
                          }

                          {
                            active_loading_order_tabs === "Loading Order PDF" && (
                              <>
                                {
                                  page_data?.loading_order?.loading_order_status?.toLowerCase() !== app_consts.UNDERGOING_PROCESSING?.toLowerCase() ?
                                    <>
                                      <Block>
                                        <BlockHead>
                                          <BlockTitle tag="h5">Loading Order PDF</BlockTitle>
                                          <p>Printable Doucment with Loading Order Details</p>
                                        </BlockHead>
                                        <div className='p-2 border text-gray'>
                                          <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                                            <PDFViewer height="100%" width="100%" showToolbar>
                                              <LoadingOrderPDF page_data={page_data?.loading_order} />
                                            </PDFViewer>
                                          </div>
                                        </div>
                                      </Block>
                                    </>
                                    :
                                    <>
                                      <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                                        <BiErrorCircle className="text-danger fs-13" />
                                        <p>Cannot View Loading Order PDF.</p>
                                        <p>Loading Order Processing is Incomplete.</p>
                                      </div>
                                    </>
                                }
                              </>
                            )
                          }
                        </>
                      )
                    }
                  </div>
                </>
          }
        </Block>
      </Content >

      <ModalAdd
        openModal={add_products_to_direct_delivery}
        setOpenModal={setAddProductsToDirectDelivery}
        modalTitle="Add Products to Delivery Note"
        type={app_consts.ADD_PRODUCTS_TO_DIRECT_DELIVERY}
        succFunc={successAddProductsFunction}
        size="xl"
        page_data={page_data}
        fullscreen
      />


      <ModalAdd
        openModal={add_products_to_warehouse_delivery}
        setOpenModal={setAddProductsToWarehouseDelivery}
        modalTitle="Add Products to Delivery Note"
        type={app_consts.ADD_PRODUCTS_TO_WAREHOUSE_DELIVERY}
        succFunc={successAddProductsFunction}
        size="xl"
        page_data={page_data}
        fullscreen
      />

      <ModalAdd
        openModal={finalize_dn_modal}
        setOpenModal={setFinalizeDnModal}
        modalTitle="Finalize Delivery Note"
        type={app_consts.FINALIZE_DN}
        succFunc={successFinalizeDnFunction}
        size="lg"
        page_data={page_data}
      />
    </>
  );
};

export default DeliveryNoteDetails;
